import React from 'react';
import FeedbackIcon from '@atlaskit/icon/glyph/feedback';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { P300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { usePageContext } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/page-context/main.tsx';
import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import messages from './messages';

type Props = {
	formatMessage: FormatMessage;
	onClickLearnAboutImprovedSLAs: () => void;
};

export const AwarenessBannerForHierarchicalGoals = ({
	formatMessage,
	onClickLearnAboutImprovedSLAs,
}: Props) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const cloudId = useCloudId();
	const [{ data: pageContextData }] = usePageContext();
	const { projectId } = pageContextData?.projectContext || {};

	return (
		<SectionMessage
			title={formatMessage(messages.sectionMessageTitle)}
			appearance="discovery"
			icon={() => <FeedbackIcon label="" primaryColor={token('color.icon.discovery', P300)} />}
			actions={[
				<SectionMessageAction
					key="updatedLearnMoreAboutImprovedSLAs"
					onClick={() => {
						fireUIAnalytics(
							createAnalyticsEvent({
								actionSubject: 'link',
								actionSubjectId: 'learnMoreAboutHierarchicalGoalLinkClick',
								action: 'clicked',
							}),
							'learnMoreAboutHierarchicalGoalLinkClick',
							{
								tenantId: cloudId,
								projectId,
							},
						);
						onClickLearnAboutImprovedSLAs();
					}}
				>
					{formatMessage(messages.learnMoreAboutImprovedSla)}
				</SectionMessageAction>,
			]}
		>
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
			<p>{formatMessage(messages.sectionMessageDescription)}</p>
		</SectionMessage>
	);
};
